import {
  createCategory,
  deleteCategory,
  getAllCategories,
  type Category,
} from './servicesStore';

export type { Category };

export const categoryService = {
  async getCategories(): Promise<Category[]> {
    return getAllCategories();
  },

  async addCategory(name: string): Promise<Category> {
    return createCategory(name);
  },

  async deleteCategory(id: string): Promise<void> {
    await deleteCategory(id);
  },
};
